import React, { useState, useEffect, useContext } from 'react';
import parse from 'html-react-parser';
import LinkModal from './LinkModal';
import PlaylistTableModal from './PlaylistTableModal';
import PlaylistsTable from './PlaylistsTable';


import { Link, useNavigate, useLocation } from "react-router-dom";
import { GlobalStateContext } from './GlobalState';
import runner1image from './s2rimages/runner2.jpeg';
const Home = () => {
  const [parsedHtml, setParsedHtml] = useState(null);
  const { setIsLoggedInSpotify, isLoggedInSpotify } = useContext(GlobalStateContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const inSpotify = searchParams.get('inspotify') === 'true';
    setIsLoggedInSpotify(inSpotify);
    console.log('useEffect# isLoggedInSpotify', inSpotify);

  }, [location.search, setIsLoggedInSpotify]);

  const handlePublicAccess = () => {
    setIsLoggedInSpotify(false);
    navigate('/builder');
    console.log('handlePublicAccess# isLoggedInSpotify falsed', isLoggedInSpotify);
  };


  return (
    <div className="container">
      <h1 className="cover-heading">Welcome, Runner</h1>
      <p className="lead">Here is how you can build your perfect running playlist </p>
      <div className="text-center">
        <img
          src={require("./s2rimages/corkrun-g1.png")}
          alt="Run with music"
          className="img-fluid mx-auto d-block"
          style={{ maxWidth: '80%' }}
        />
      </div>
      <br />
      <br /> <br />

      <div className="row">
        <div className="col-4 text-center">
          <i className="bi bi-music-note-list h1"></i>
          <p>
            Load some songs from your Spotify library or search for new ones.
          </p>
        </div>
        <div className="col-4 text-center">
          <i className="bi bi-music-note-beamed h1"></i>
          <p>
            Customize the playlist by adjusting the order and intensity of songs
            to fit your running pace.
          </p>
        </div>
        <div className="col-4 text-center">
          <i className="bi bi-save h1"></i>
          <p>Finally, save your playlist and start the Spotify player.</p>
        </div>
      </div>
      <br />
      <br />
      <p>
        <strong style={{ fontSize: "1.5em" }}>
          .. and start running!
        </strong>
      </p>



      <div className="d-flex justify-content-center gap-3">
        {isLoggedInSpotify ? (
          <Link to="/builder" className="btn btn-primary">
            Let's go!
          </Link>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <button
              onClick={handlePublicAccess}
              className="btn btn-primary mb-4"
            >
              Try without Spotify Login!
            </button>
            <a href="/login-home" className="mt-2">
              Or click here to Go Back and Login with Spotify to use full features
            </a>


          </div>


        )}
      </div>

      <div className="text-center mt-3">
        <Link to="/chat" className="text-white-50 text-decoration-none">
          <small>Or go directly to Chat Assistant</small>
        </Link>
      </div>

      <br />
      <br />



    </div>
  );
};

export default Home;
